/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */
/* eslint-disable */

import React, { useState, useEffect } from "react";
import "./landingStyles.css";

import ProductCards from "../../components/cards/ProductCard/ProductCards";
import HeroContainer from "../../components/containers/Hero/heroContainer";
import SavingContainer from "../../components/containers/Saving/savingContainer";
import SectionComponent from "../../components/containers/Section/SectionComponent";
import { SectionsContext } from "../../components/containers/Section/SectionsContext";
import VideoContainer from "../../components/containers/Video/VideoContainer";
import SimulationComponent from "../../components/containers/Simulation/SimulationComponent";
import { useInView } from "react-intersection-observer";
import ResetPasswordDialog from "../../components/dialogs/ResetPassword/ResetPasswordDialog";
import { useLocation } from "react-router";
import STATIC_ROUTES from "../../route/STATIC_ROUTES";
import ConfirmRegistration from "../../containers/auth/ConfirmRegistration";
// import ResetPasswordDialog from "../../dialogs/ResetPassword/ResetPasswordDialog";

const LandingPage = React.memo(() => {
  const windowSize = window.innerWidth;

  const location = useLocation();

  // Refs for the fade in
  const [fastResults, setFastResults] = useState(false);
  const [aspice, setAspice] = useState(false);
  const [motor, setMotor] = useState(false);
  const [tools, setTools] = useState(false);
  const [simulationComponent, setSimulationComponent] = useState(false);
  const [behaviouralModel, setBehaviouralModel] = useState(false);
  const [savingContainer, setSavingContainer] = useState(false);
  const [videoContainer, setVideoContainer] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);

  const [token, setToken] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const parts = location.pathname.split("/");
    const urlString = parts[1];
    const staticParts = STATIC_ROUTES.confirmRegistration.split("/");
    const staticRoutesString = staticParts[1];
    setIsConfirming(urlString === staticRoutesString);
  }, []);

  const handleCloseConfirming = () => {
    setIsConfirming(false);
  };

  const fastResult = useInView({
    threshold: 0.9,
    triggerOnce: true,
  });

  const aspice_cds = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const motor_control = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const c_tools = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const simulation = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const behavioural = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const saving = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const video = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  useEffect(() => {
    if (fastResult.inView) {
      setFastResults(true);
    } else {
      setFastResults(false);
    }

    if (aspice_cds.inView) {
      setAspice(true);
    } else {
      setAspice(false);
    }

    if (motor_control.inView) {
      setMotor(true);
    } else {
      setMotor(false);
    }

    if (c_tools.inView) {
      setTools(true);
    } else {
      setTools(false);
    }
  }, [fastResult.inView, aspice_cds.inView, motor_control.inView, c_tools.inView]);

  useEffect(() => {
    if (simulation.inView) {
      setSimulationComponent(true);
    } else {
      setSimulationComponent(false);
    }

    if (behavioural.inView) {
      setBehaviouralModel(true);
    } else {
      setBehaviouralModel(false);
    }

    if (saving.inView) {
      setSavingContainer(true);
    } else {
      setSavingContainer(false);
    }

    if (video.inView) {
      setVideoContainer(true);
    } else {
      setVideoContainer(false);
    }
  }, [simulation.inView, behavioural.inView, saving.inView, video.inView]);

  const code = window.location.search;

  useEffect(() => {
    if (code) {
      const code_token = window.location.search.slice(7);
      setToken(code_token);
      setOpen(true);
    }
  }, []);

  return (
    <div className="landing_container">
      {isConfirming ? (
        <ConfirmRegistration open={isConfirming} handleClose={handleCloseConfirming} />
      ) : null}
      <HeroContainer />
      <div
        ref={fastResult.ref}
        style={fastResults ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <SectionComponent
          key={SectionsContext[0].id}
          title={SectionsContext[0].title}
          subTitle={SectionsContext[0].subTitle}
        />
      </div>
      <div
        ref={video.ref}
        style={videoContainer ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <VideoContainer />
      </div>
      <div
        ref={aspice_cds.ref}
        style={aspice ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <SectionComponent
          key={SectionsContext[1].id}
          title={SectionsContext[1].title}
          subTitle={SectionsContext[1].subTitle}
          img={SectionsContext[1].img}
          type="aspice"
        />
      </div>

      <div
        ref={motor_control.ref}
        style={motor ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <SectionComponent
          key={SectionsContext[2].id}
          title={SectionsContext[2].title}
          img={windowSize <= 800 ? SectionsContext[2].img2 : SectionsContext[2].img}
        />
      </div>
      <div ref={c_tools.ref} style={tools ? transitionStyles.onScreen : transitionStyles.offScreen}>
        <SectionComponent
          key={SectionsContext[3].id}
          title={SectionsContext[3].title}
          subTitle={SectionsContext[3].subTitle}
          img={SectionsContext[3].img}
        />
      </div>
      <div
        ref={saving.ref}
        style={savingContainer ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <SavingContainer />
      </div>
      <ProductCards />

      <div
        ref={simulation.ref}
        style={simulationComponent ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <SimulationComponent
          title={SectionsContext[4].title}
          subTitle={SectionsContext[4].subTitle}
        />
      </div>
      <div
        ref={behavioural.ref}
        style={behaviouralModel ? transitionStyles.onScreen : transitionStyles.offScreen}
      >
        <SectionComponent
          key={SectionsContext[5].id}
          title={SectionsContext[5].title}
          subTitle={SectionsContext[5].subTitle}
          img={SectionsContext[5].img}
          type="behavioural"
        />
      </div>
      <ResetPasswordDialog open={open} setOpen={setOpen} token={token} create={true} />
    </div>
  );
});

export default LandingPage;

const transitionStyles = {
  onScreen: {
    position: "relative",
    opacity: "1",
    transition: "all 2.5s",
  },
  offScreen: {
    position: "relative",
    opacity: "0",
  },
};
